import React from "react";
import UpdatesSection from "components/UpdatesSection";
import Head from 'next/head';

function UpdatesPage(props) {
  return (
    <>
      <Head>
        <title>Product Updates & New Features | tabExtend</title>
        <meta 
          name="description" 
          content="Stay up to date with the latest features and improvements to tabExtend. See our changelog for browser tab management, note-taking, and productivity enhancements." 
        />
        <meta property="og:title" content="Product Updates & New Features | tabExtend" />
        <meta 
          property="og:description" 
          content="Stay up to date with the latest features and improvements to tabExtend. See our changelog for browser tab management, note-taking, and productivity enhancements."
        />
        <link rel="canonical" href="https://www.tabextend.com/updates" />
      </Head>
      <UpdatesSection
        color="primary"
        size="large"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="We help you make money"
        subtitle="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorum consequatur numquam aliquam tenetur ad amet inventore hic beatae, quas accusantium perferendis sapiente explicabo, corporis totam!"
      ></UpdatesSection>
    </>
  );
}

export default UpdatesPage;
